import { Injectable } from '@angular/core';
import { ApiUrlBuilder } from '@cdw-ae/routes-shared-api';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlBuilderService extends ApiUrlBuilder {
  constructor() {
    super({
      backendApi: { baseUrl: environment.urls.backendApi },
    });
  }
}
